import React, { createContext, useContext, useState } from "react";
import {
  ILocaleContextType,
  ISupportedLocales,
} from "../../Orchestrator/Types/Interface/ICustomer";

// Create a context with default values
const LocaleContext = createContext<ILocaleContextType | undefined>(undefined);

// Create a provider component
export const LocaleProvider: React.FC<{
  children: React.ReactNode;
  initialLocale: ISupportedLocales;
}> = ({ children, initialLocale }) => {
  const [locale, setLocale] = useState<ISupportedLocales>(initialLocale);
  return (
    <LocaleContext.Provider value={{ locale: initialLocale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

// Custom hook to use the locale context
export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }
  return context;
};
